import axios from "axios";
import { appendPaginationQuery } from "./appendPaginationQuery";
import { parsePagedResponse } from "./parsePagedResponse";

/**
 * POST a paginated filtered list request; if the current page is empty but not the
 * first page, retries once on the previous page (e.g. after deleting the last item).
 */
export async function fetchPostWithEmptyPageRetry({
  endpointUrl,
  requestBody,
  pageToFetch,
  pageSize,
}) {
  const url = appendPaginationQuery(endpointUrl, pageToFetch, pageSize);
  const response = await axios.post(url, requestBody);
  let parsed = parsePagedResponse(response.data);

  if (parsed.items.length === 0 && pageToFetch > 0 && parsed.totalPages > 0) {
    const previousPage = Math.min(pageToFetch - 1, parsed.totalPages - 1);
    if (previousPage !== pageToFetch) {
      const retryUrl = appendPaginationQuery(endpointUrl, previousPage, pageSize);
      const retryResponse = await axios.post(retryUrl, requestBody);
      parsed = parsePagedResponse(retryResponse.data);
    }
  }

  return parsed;
}
